(function () {
  if (customElements.get('ce-sticky-header') !== undefined) {
    return;
  }

  class StickyHeader extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        section: '.shopify-section.shopify-section-group-group-header[id$="__header"]',
      };

      this.elements = null;
    }

    get behavior() {
      return this.getAttribute('behavior');
    }

    set behavior(value) {
      this.setAttribute('behavior', value);
    }

    static get observedAttributes() {
      return ['behavior'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'behavior':
          if (newValue !== null) {
            if (newValue === 'static') {
              requestAnimationFrame(() => {
                this.elements.section.classList.replace('behavior-sticky', 'behavior-static');
              });
            } else {
              requestAnimationFrame(() => {
                this.elements.section.classList.replace('behavior-static', 'behavior-sticky');
              });
            }
          }
          break;
      }
    }

    parsedCallback() {
      this.elements = {
        marker: document.createElement('div'),
        section: document.querySelector(this.selectors.section),
      };

      this.elements.section.insertAdjacentElement('beforebegin', this.elements.marker);

      this._initResizeObserver();

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.intersectionObserver.disconnect();
      this.resizeObserver.disconnect();
    }

    _initResizeObserver() {
      const callback = () => {
        this._initIntersectionObserver();
      };

      this.resizeObserver = new ResizeObserver(callback);
      this.resizeObserver.observe(this);
    }

    _initIntersectionObserver() {
      this.intersectionObserver?.disconnect();

      const callback = (entries) => {
        for (let entry of entries) {
          if (entry.isIntersecting) {
            this.behavior = 'static';
          } else {
            this.behavior = 'sticky';
          }
        }
      };

      this.intersectionObserver = new IntersectionObserver(callback);
      this.intersectionObserver.observe(this.elements.marker);
    }
  }

  customElements.define('ce-sticky-header', StickyHeader);
})();
